var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showDaysLeft)?_c('div',{class:{
    [_vm.$style.daysLeft]: true,
    [_vm.$style.daysLeftExpanded]: _vm.expanded
  }},[_c('span',{class:_vm.$style.daysLeftCount},[_vm._v(_vm._s(_vm.daysLeft))]),_c('div',{class:_vm.$style.daysLeftText},[_vm._v(" days "),_c('span',[_vm._v("left")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }